const ACTIONS = {
  APPEND_KEY: "append-key",
};

export { ACTIONS };
